import styled from 'styled-components';
import dt from '../../../shared/theme';

const Button = styled.button`
  background-color: ${props => dt(props).theme.bodyBackgroundColor};
  border-color: #D7DFE7;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  outline: none;

  &.pressed {
    border-color: ${props => dt(props).theme.primaryColor};
  }

  &:first-child.wire-like {
    border: 1px solid transparent;
    padding: 0 12px 0 8px;
    margin-right: 8px;

    ${props => dt(props).theme.isLarge && `
      &:hover {
        border: 1px solid #D7DFE7;
      }
    `}
  }

  > .icon-lw {
    margin-top: -4px;
    color: ${props => dt(props).theme.bodyColor};
  }

  > .number,
  > .text {
    margin-left: 8px;
    color: ${props => dt(props).theme.bodyColor};
    font: ${props => dt(props).theme.fontWeightHeavy} 16px/19.2px ${props => dt(props).theme.fontFamilyBody};
    min-width: 8px;
  }
`;

export default Button;
